import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'typed-redux-saga';

import { SCREENS } from '../../../shared/helpers/navigation';
import { resetAllFilters } from '../features/filter/slice';

export function* handleNavigateSaga({ payload: screen }: PayloadAction<SCREENS>) {
    if (screen === SCREENS.CONFERENCES_HISTORY) {
        yield* put(resetAllFilters());
    }
}
